import React, { useContext, useState, useEffect } from 'react';
import useAxios from 'axios-hooks';
import { Helmet } from 'react-helmet-async';
import DOMPurify from 'dompurify';
import { GeneralContext } from '../../../context/generalContext';
import { getBaseUrl } from '../../../functions/getBaseUrl';
import classes from './AboutInfo.module.scss';

export default function AboutInfo() {
  const { activeLanguage, path } = useContext(GeneralContext);

  const [currentAboutPath, setCurrentAboutPath] = useState('');
  useEffect(() => {
    activeLanguage === 1 ? setCurrentAboutPath(path.slice(1)) : setCurrentAboutPath(path.slice(4));
  }, [activeLanguage, path]);

  const [{ data }] = useAxios({
    url: `${getBaseUrl()}/api/content?url=/${currentAboutPath}`,
    method: 'POST',
  });

  return (
    <div className={classes.AboutInfoWrap}>
      {data && (
        <>
          <Helmet>
            <title>{activeLanguage === 1 ? data?.title : data?.title_en}</title>
          </Helmet>
          <h1
            className={classes.AboutInfoTitle}
            dangerouslySetInnerHTML={{
              __html: activeLanguage === 1 ? DOMPurify.sanitize(data?.title) : DOMPurify.sanitize(data?.title_en),
            }}
          />
          <div
            className={classes.AboutInfoContent}
            dangerouslySetInnerHTML={{
              __html:
                activeLanguage === 1 ? DOMPurify.sanitize(data?.main_text) : DOMPurify.sanitize(data?.main_text_en),
            }}
          />
        </>
      )}
    </div>
  );
}
